// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0846dfce","446":"e7414d7f"}[chunkId] + ".chunk.js";
};